import React from 'react';
import styled from 'styled-components';
import I10n from '../features/i10n';
import { SECONDARY_COLOR } from '../color-constants';
import LicenceSelectorQuestion from './licence_selector_question';
import Checkbox from '../atoms/checkbox';

const Card = styled.div`
  display: flex;
  flex: 1 1 0px;
  flex-direction: row;
  padding: 12px 16px;
  gap: 12px;
  background: #FFFFFF;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  width: 100%;
  box-sizing: border-box;
  border: 2px solid transparent;

  ${props => props.$checked ? `border: 2px solid ${SECONDARY_COLOR};border: 2px solid var(--se-primary, ${SECONDARY_COLOR});` : '' }
`;

const TopRow = styled.div`
  display: flex;
  flex: 1 1 0px;
`;

const Image = styled.img`
  width: 80px;
  height: 80px;
  object-fit: cover;
  align-self: center;
  margin-top: 10px;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 0px;
`;

const CheckboxContainer = styled.div`
  margin-right: 10px;
`;

const TitleRow = styled.div`
  display: flex;
  align-self: flex-start;
  cursor: pointer;
  ${props => props.$disabled ? 'cursor: not-allowed;' : ''}
`;

const Title = styled.span`
  margin: 0;
  font-size: 18px;
  color: #000000;
  font-weight: 400;
`;

const Description = styled.span`
  margin: 0;
  font-size: 16px;
  color: #000000;
  font-weight: 400;
  margin-top: 10px;
`;

const ChildQuestionsWrapper = styled.div`
  display: flex;
  margin-top: 10px;
`;

class LicenceSelectorImageCheckCard extends React.Component {

  render() {
    const { answer, userAnswers, setAnswer, activeQuestions } = this.props;

    const isDisabled = answer.disabled;
    const isSelected = userAnswers[answer.criteria] === answer.value;

    return (
      <Card $checked={isSelected} $disabled={isDisabled}>
        <TopRow>
          <TextContainer>
            <TitleRow
              $disabled={isDisabled}
              onClick={() => {
                if (!isDisabled) {
                  const isSelected = userAnswers[answer.criteria] === answer.value;
                  if (isSelected) {
                    setAnswer(answer.criteria, null);
                  } else {
                    setAnswer(answer.criteria, answer.value);
                  }
                }
               }}
            >
              {!isDisabled && <CheckboxContainer>
                <Checkbox
                  size={18}
                  checked={isSelected}
                />
              </CheckboxContainer>}
              <Title>
                {I10n.getOrDefault(`screen.licence_selector.modal.answer.name.${answer.labelKey}`, answer.name)}
              </Title>
            </TitleRow>
            <Image src={answer.imageUrl} alt={answer.name} />
            {answer.hint && <Description>
              {I10n.getOrDefault(`screen.licence_selector.modal.answer.hint.${answer.labelKey}`, answer.hint)}
            </Description>}
            {isSelected && activeQuestions.filter(question => {
              return question.parentAnswer === answer.key;
            }).map((question, idx) => {
              return (
                <ChildQuestionsWrapper key={idx}>
                  <LicenceSelectorQuestion
                    activeQuestions={[]}
                    question={question}
                    userAnswers={userAnswers}
                    setAnswer={(key, value, answer) => { this.props.setAnswer(key, value, question, answer); }}
                    clearAnswers={this.props.clearAnswers}
                    softwareLicencesMap={this.props.softwareLicencesMap}
                  />
                </ChildQuestionsWrapper>
              );
            })}
          </TextContainer>
        </TopRow>
      </Card>
    );
  }
}

export default LicenceSelectorImageCheckCard;
